import React from 'react';

function OurImpactSection() {
  return (
    <section className="our-impact-section">
      <div className="container our-impact-container">
        
        {/* Left Column: Image */}
        <div className="our-impact-left">
          <div className="our-impact-img-wrapper">
            <img 
              src="/assets/images/our-impact.webp" 
              alt="Our Impact Rubik's Cube Graphic" 
              className="our-impact-img"
            />
          </div>
        </div>

        {/* Right Column: Content */}
        <div className="our-impact-right">
          <h2 className="our-impact-title">Our Impact</h2>
          <h4 className="our-impact-subtitle">Impact 2026 & Beyond!</h4>
          <p className="our-impact-description">
            Experts Communication vows to continue serving the community with social welfare and CSR efforts for communal betterment and well-being. Our vision to impact 20 million lives through better employment and education opportunities and empowerment marches toward 2026, and we will aggressively pursue the future beyond.
          </p>
        </div>

      </div>
    </section>
  );
}

export default OurImpactSection;
